const validateCpf = (cpf = '111.111.111-11') => {
  let sum = 0
  let remainder
  const str = cpf
  const cpfNumbers = str.replace(/\D/g, '')

  let allEqual = true
  for (let i = 0; i < cpfNumbers.length - 1; i += 1) {
    if (cpfNumbers[i] !== cpfNumbers[i + 1]) allEqual = false
  }
  if (allEqual) return false

  for (let i = 1; i <= 9; i += 1)
    sum += parseInt(cpfNumbers.substring(i - 1, i), 0) * (11 - i)
  remainder = (sum * 10) % 11

  if (remainder === 10 || remainder === 11) remainder = 0

  if (remainder !== parseInt(cpfNumbers.substring(9, 10), 0)) return false
  sum = 0
  for (let i = 1; i <= 10; i += 1)
    sum += parseInt(cpfNumbers.substring(i - 1, i), 0) * (12 - i)
  remainder = (sum * 10) % 11

  if (remainder === 10 || remainder === 11) remainder = 0
  if (remainder !== parseInt(cpfNumbers.substring(10, 11), 0)) return false

  return true
}

// eslint-disable-next-line import/prefer-default-export
export const cpfValidation = cpf => {
  return validateCpf(cpf)
}
